import React from 'react';

function AddAgentModal({
  agents,
  properties,
  selectedAgent,
  selectedProperties,
  onAgentChange,
  onPropertyToggle,
  onCancel,
  onSubmit,
}) {
  const selectedAgentDetails = agents.find(agent => String(agent.id) === String(selectedAgent));

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content" role="dialog" aria-modal="true" aria-labelledby="add-agent-title" onClick={(event) => event.stopPropagation()}>
        <div className="modal-header">
          <h3 id="add-agent-title">افزودن نماینده جدید</h3>
          <button type="button" className="modal-close" onClick={onCancel} aria-label="بستن">بستن</button>
        </div>

        <div className="modal-body">
          <div className="form-section">
            <label htmlFor="property-agent-select">انتخاب نماینده:</label>
            {agents.length === 0 ? (
              <p className="empty-state">هیچ نماینده فعالی یافت نشد</p>
            ) : (
              <select
                id="property-agent-select"
                value={selectedAgent || ''}
                onChange={(event) => onAgentChange(event.target.value || null)}
                className="agent-select"
              >
                <option value="">-- یک نماینده انتخاب کنید --</option>
                {agents.map(agent => (
                  <option key={agent.id} value={agent.id}>
                    {agent.full_name} ({agent.email || agent.phone})
                  </option>
                ))}
              </select>
            )}
            {selectedAgentDetails && (
              <div className="selected-info">نماینده انتخاب شده: {selectedAgentDetails.full_name}</div>
            )}
          </div>

          <div className="form-section">
            <span className="modal-field-label">انتخاب املاک:</span>
            {properties.length === 0 ? (
              <p className="empty-state">شما هیچ ملکی برای اختصاص ندارید</p>
            ) : (
              <div className="property-checkbox-list">
                {properties.map(property => (
                  <label key={property.id} className="property-checkbox-item">
                    <input
                      type="checkbox"
                      checked={selectedProperties.includes(property.id)}
                      onChange={() => onPropertyToggle(property.id)}
                    />
                    <span>{property.name || `ملک ${property.id}`}</span>
                    <span className="property-address">{property.address || 'بدون آدرس'}</span>
                  </label>
                ))}
              </div>
            )}
            {selectedProperties.length > 0 && (
              <div className="selected-info">{selectedProperties.length} ملک انتخاب شده</div>
            )}
          </div>
        </div>

        <div className="modal-footer">
          <button type="button" className="modal-cancel-button" onClick={onCancel}>انصراف</button>
          <button
            type="button"
            className="modal-submit-button"
            onClick={onSubmit}
            disabled={!selectedAgent || selectedProperties.length === 0}
          >
            افزودن نماینده
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddAgentModal;
